<template>
  <div class="chart-panel">
    <div class="chart-header">
      <div class="time-selector-group">
        <div class="time-selector" :class="{ selected: $store.state.angleTimeRange === '1h' }"
          @click="clickTime('h', $event)">近1小时
        </div>
        <div class="time-selector" :class="{ selected: $store.state.angleTimeRange === '1d' }"
          @click="clickTime('d', $event)">近24小时
        </div>
        <div class="time-selector" :class="{ selected: $store.state.angleTimeRange === '1w' }"
          @click="clickTime('w', $event)">近7天
        </div>
      </div>
    </div>
    <stackedLineEchart ref="chart" :chartDataX="dataX" :chartDataY="dataY" :legendData="dataLegend"
      :show-date="this.$store.state.angleTimeRange === '1w'" title="倾角" style="width: 100%;height: calc(100% - 20px);">
    </stackedLineEchart>

    <echartItemDialog ref="echartItemDialog"></echartItemDialog>
  </div>
</template>

<script>
import echartItemDialog from "./echartItemDialog";
import stackedLineEchart from "./stackedLineEchart";
export default {
  components: { echartItemDialog, stackedLineEchart },
  data() {
    return {
      dataX: [],
      dataY: [],
      dataLegend: []
    };
  },
  mounted() { },
  updated() {
    // this.$refs.chart.initChart();
  },
  methods: {
    setData(data) {
      this.dataX = data.chartDataX;
      this.dataY = data.chartDataY;
      this.dataLegend = data.dataLegend;
    },
    clickTime(t, e) {
      if (e.target.innerText === '近24小时') {
        localStorage.setItem("angleTimeRange", "1d");
        this.$store.state.angleTimeRange = '1d'
      } else if (e.target.innerText === '近7天') {
        localStorage.setItem("angleTimeRange", "1w");
        this.$store.state.angleTimeRange = '1w'
      } else {
        localStorage.setItem("angleTimeRange", "1h");
        this.$store.state.angleTimeRange = '1h'
      }

    },
    clickDetail() {
      let movementSensor = "";
      this.$store.state.curSensorList.forEach(item => {
        if (item.sensorType === 2) {
          movementSensor = item.edgeCode + "_" + item.usbPort;
        }
      })
      this.$refs.echartItemDialog.show(movementSensor, 4);
    },
  },
  computed: {},
};
</script>

<style scoped>
.chart-panel {
  height: calc(100% - 17px);
  width: 100%;
}

.chart-header {
  height: 20px;
}

.selected {
  border-color: #5BB3BC;
  color: #5BB3BC;
}
</style>



// WEBPACK FOOTER //
// src/components/angle-chart.vue